export const capacityDropdown = [
    {
        value: "temporary",
        name: "temporary",
    },
    {
        value: "permanent",
        name: "permanent",
    }
  ];